import React from 'react';
import type { Place } from '../../types/place';
import { useViewedDataProgress } from '../../hooks/useViewedDataProgress';
import { useParams } from 'react-router-dom';
import { Box, Typography } from '@mui/material';
import { motion } from 'framer-motion';
import { useAppSelector } from '../../redux/hooks';
import { selectCurrentLanguage, selectDirection, selectMainPlace } from '../../redux/selectors';

import textsMapper from '../../staticTexts/texts'

interface ViewedProgressProps {
    parentId: string | number;
}

const ViewedProgress: React.FC<ViewedProgressProps> = ({parentId}) => {
    const {slug} = useParams<{ slug: string }>()
    const {getProgress} = useViewedDataProgress(slug)
    const currentLanguage = useAppSelector(selectCurrentLanguage)
    const direction = useAppSelector(selectDirection)
    const mainPlace = useAppSelector(selectMainPlace)
    
    const progress = getProgress(parentId)
    const language = (currentLanguage ?? 'en').replace('-', '');
    const progressTexts = textsMapper.components.progressBar as Record<string, { title: string; text: readonly string[] }>;
    const pb = progressTexts[language];

    const calculateActualProgress = (): { viewed: number; total: number } => {
        if (!mainPlace?.children || !progress) return { viewed: 0, total: 0 };
        
        const children = mainPlace.children;
        const totalStations = children.filter((child: Place) => 
            child.type !== 'intro' && child.thumbnail_type !== 'minor'
        ).length;
        
        const viewedStations = progress.viewed?.filter((viewedId: string | number) => {
            const station = children.find((child: Place) => child.id.toString() === viewedId.toString());
            return station && station.thumbnail_type !== 'minor';
        }) || [];
        
        return {
            viewed: viewedStations.length,
            total: totalStations
        };
    };

    const actualProgress = calculateActualProgress();

    return (
        <div>
            <Box sx={{display: 'flex', justifyContent: 'space-between', direction: direction}}>
                <Typography variant='body1'>{pb?.title ?? ''}</Typography>
                <Typography variant='body1'>{`${pb?.text[0] ?? ''} ${actualProgress.viewed} ${pb?.text[1] ?? ''} ${actualProgress.total}`}</Typography>
            </Box>

            <Box
                sx={{
                    bgcolor: 'rgb(189, 188, 188)',
                    boxSizing: 'border-box',
                    display: 'flex',
                    justifyContent: 'space-between',
                    margin: '0 auto',
                    alignItems: 'center',
                    color: 'black',
                    position: 'relative',
                    overflow: 'hidden',
                    borderRadius: '1rem',
                    height: '6px',
                    marginTop: '1rem'
                }}
            >
                <motion.div
                    initial={{ width: 0 }}
                    animate={{ width: `${actualProgress.total > 0 ? (actualProgress.viewed / actualProgress.total * 100) : 0}%` }}
                    transition={{ duration: 1, ease: 'easeInOut' }}
                    style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        height: '100%',
                        backgroundColor: 'rgb(0, 0, 0)',
                        borderRadius: 'inherit',
                        zIndex: 0
                    }}
                />

                <Box sx={{ 
                    position: "relative", 
                    zIndex: 1, 
                    display: "flex", 
                    alignItems: "center", 
                    width: "100%", 
                    justifyContent: "center", 
                    fontSize: '1.5vw' 
                }}>
                    <div className="icon" style={{ width: "25px" }}></div>
                    
                </Box>
            </Box>
        </div>
    );
};

export default ViewedProgress;
